"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.tester.name': 'Nome Tester',
    'botTest.tester.model': 'Modello IA',
};
